import { render, staticRenderFns } from "./assignteacher.vue?vue&type=template&id=4df07cf8&"
import script from "./assignteacher.vue?vue&type=script&lang=js&"
export * from "./assignteacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports